
import axios from 'axios'

export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_ADMIN_URL || 'https://e-chat.mongol.net/complete_admin',
  timeout: 5000,
  headers: { 'Content-Type': 'application/json' ,  'operationID': '1001' },
})

export const axionsInstanceBaseApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://e-chat.mongol.net/api',
  timeout: 5000,
  headers: { 'Content-Type': 'application/json' ,  'operationID': '1001' },
})

export const axionsInstanceAdminApi = axios.create({
  baseURL:  'https://e-chat.mongol.net/chat',
  timeout: 5000,
  headers: { 'Content-Type': 'application/json' ,  'operationID': '1001' },
})
